module.exports = __webpack_public_path__ + "static/media/video-comic.01db3679.png";